import React from "react";
import Container from "src/components/common/Layout/Container";
import { CategoryProps } from "pages/[city]/[category]";
import { colors } from "src/config/colors";
import { Typography } from "@mui/material";
import AlphabetSearch from "src/components/FirstCategoryPage/components/AlphabetSearch/AlphabetSearch";
import CustomChipList from "src/components/common/CustomChipList/CustomChipList";
import { useQuery } from "src/utils/hooks/common/useQuery";
import DangerouslyHtml from "src/components/common/DangerouslyHtml/DangerouslyHtml";

interface CategoryPageProps extends CategoryProps {
  pageTitle?: string;
}

const FirstCategoryPage: React.FC<CategoryPageProps> = ({
  subcategories,
  pageTitle,
  brandsAbc,
  categoryHtmlText,
}) => {
  const { city } = useQuery(["city"]);

  return (
    <>
      <Container isWithPaper marginBottom={4}>
        <Typography
          paddingY="20px"
          fontSize="30px"
          fontWeight={550}
          color={colors.darkBlue}
          component="h1"
          mb={2}
        >
          {pageTitle}
        </Typography>
        <CustomChipList city={city} data={subcategories} />
        <DangerouslyHtml innerHtml={categoryHtmlText?.html_text} />
        <AlphabetSearch brandsAbcData={brandsAbc} />
      </Container>
    </>
  );
};

export default FirstCategoryPage;
